import React from 'react';
import ReactPlayer from 'react-player/lazy';
import { useStyles } from './VideoViewer.styles';
import theme from '../../../../styles/theme';

interface VideoViewerProps {
  url: string;
}

export default function VideoViewer({ url }: VideoViewerProps) {
  const { classes } = useStyles(theme);

  return (
    <div className={classes.videoViewerWrapper}>
      <ReactPlayer controls url={url} width={600} />
    </div>
  );
}
